import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductsByCategory } from '../../services/productService';
import Loader from '../Loader';
import ProductCard from './ProductCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import './Product.module.css';
import { Navigation } from 'swiper/modules';

const ProductCarousel = ({ categoryId }) => {
  const dispatch = useDispatch();
 
  const {productByCat, loader} = useSelector(state => state.product);
  //console.log('product' , productByCat);

  useEffect(() => {
    if (categoryId) {
      dispatch(fetchProductsByCategory(categoryId));  
    }
  }, [categoryId, dispatch]);

  if (loader) return <Loader />;

  return (
    <div className="relative">
      <h2 className="text-xl font-semibold mb-4">Produits similaires</h2>
      <div className="flex overflow-x-scroll space-x-4">
      <Swiper modules={[Navigation]} navigation={true} spaceBetween={10} slidesPerView={3} loop={false}>
        {productByCat?.length > 0 ? (
          productByCat.map((product) => (
            <SwiperSlide key={product.id}>
              <ProductCard product={product} />
            </SwiperSlide>
          ))
        ) : (
          <p>Aucun produit trouvé dans cette catégorie.</p>
        )}
      </Swiper>
      </div>
    </div>
  );
};

export default ProductCarousel;
